import React from 'react';
import useLoadDashboardConfig from '../utils/useLoadDashboardConfig';
import NewDashboardLink from './NewDashboardLink';
import MyDashboardsController from './MyDashboards';
import PublishedDashboardsController from './PublishedDashboards';
import FavoriteDashboardsController from './FavoriteDashboards';
import SharedDashboardsController from './SharedDashboards';
import DashboardModalController from './DashboardModalController';
import {
  DashboardNavContainer,
  FixedSection,
  ScrollableSection,
} from './DashboardNavUI';
import useFormulaConfigWeekStartEffect from '../../Formulas/utils/useFormulaConfigWeekStartEffect';
import ThinDivider from '../../../components/ThinDivider';

const DashboardNav = () => {
  useLoadDashboardConfig();
  useFormulaConfigWeekStartEffect();

  return (
    <DashboardNavContainer>
      <FixedSection>
        <NewDashboardLink />
        <ThinDivider layout="horizontal" size="full" />
      </FixedSection>
      <ScrollableSection>
        <FavoriteDashboardsController />
        <MyDashboardsController />
        <PublishedDashboardsController />
        <SharedDashboardsController />
        <DashboardModalController />
      </ScrollableSection>
    </DashboardNavContainer>
  );
};

export default DashboardNav;
